import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConstant } from '@d-constants';
import { environment } from '@d-environments/environment';
import { CoreTenantTreeModel, ITenantTree } from '@d-models/other/tenant.model';
// import { AuthService } from '@d-services/wms/auth.service';
import { AppState, UserState } from '@d-store/constant';
import { getCurrentUser } from '@d-store/user/user.selector';
import { select, Store } from '@ngrx/store';
import { map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CoreUserService {
  private baseUrl: string = environment.coreApp.url + '/Users';
  private user!: any;
  constructor(
    private httpClient: HttpClient,
    // private authService: AuthService,
    private store: Store<AppState>,
  ) {
    // this.store.pipe(select(getCurrentUser)).subscribe((val) => {
    //   // localStorage.setItem(
    //   //   AppConstant.LocalStorageKey.DIALOGUser,
    //   //   JSON.stringify(val),
    //   // );
    //   this.user = val;
    // });
    this.user = {
      level: {},
    };
  }

  getTenantTree() {
    const url = `${this.baseUrl}/GetTenantTree`;

    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: '',
      }),
    };

    return this.httpClient
      .get<ITenantTree[]>(url, httpOptions)
      .pipe(map((val) => val.map((item) => new CoreTenantTreeModel(item))));
  }

  getUserLevel() {
    return this.user.level;
  }

  getProgramOwnerId() {
    return this.user.level.programOwnerId;
  }

  getCurrentProgramOwnerName() {
    return this.user.level.name;
  }

  getCurrentTenant() {
    return this.user.currentTenant;
  }

  getCurrentUser() {
    return this.user.user;
  }

  getTenantTreeItems() {
    return this.user.tenants;
  }
}
